<template>
  <el-dialog v-dialogDrag :visible.sync="specDialogVisible" title="添加专业" width="600px" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <div style="margin:10px 0px;display: flex;justify-content: space-between;">
      <el-input v-model="searchValue" :placeholder="'输入专业名称/编号搜索'" size="small" @keyup.enter.native="search" />
    </div>
    <el-table ref="multipleTable" :data="searchList" tooltip-effect="dark" style="width: 100%;min-height:300px"
      height="calc(100% - 50px)" border @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="49" align="center" />
      <el-table-column prop="specName" label="专业名称" align="left" sortable />
      <el-table-column prop="templateSpecId" label="专业编号" align="left" sortable />
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="specDialogVisible = false">取 消</el-button>
      <el-button v-preventReClick size="small" type="primary" @click="submit()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import service from "@/CommonDP/service/folder-service";
export default {
  props: {
    first: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Object,
      required: false,
      default: () => {}
    },
    data: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      specDialogVisible: false,
      selectionData: [],
      specList: [],
      searchValue: '',
      searchList: []
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    filteredSpecList() {
      // 过滤已添加的数据
      if (!this.specDialogVisible) return [];
      const existChildSpecIds = this.treeData?.childrenList?.map(item => item.typeId) || [];
      const dataChildSpecIds = this.data?.map(item => item.typeId) || [];
      return this.specList.filter((item) => {
        if (this.first) {
          return !dataChildSpecIds.includes(item.specId);
        } else {
          return !existChildSpecIds.includes(item.specId);
        }
      });
    }

  },
  watch: {
    searchValue(newValue) {
      if (!newValue) {
        this.searchList = this.filteredSpecList;
      }
    }
  },
  methods: {
    show() {
      this.searchValue = "";
      this.searchList = [];
      this.selectionData = [];
      this.specList = [];
      this.specDialogVisible = true;
      this.querySpecList();
    },
    async querySpecList() {
      const params = { enterpriseId: this.enterpriseId };
      const res = await service.queryspeclist2(params);
      this.specList = res.data || [];
      this.search();
    },
    submit() {
      if (!this.selectionData.length) {
        this.$warn("请勾选要添加的专业");
        return;
      }
      const data = { type: "spec", val: 2, selectionData: this.selectionData, parentNodeData: this.treeData };
      this.$emit("callback", data);
      this.specDialogVisible = false;
    },
    handleSelectionChange(val) {
      this.selectionData = val;
    },
    search() {
      const { searchValue: name } = this;
      setTimeout(() => {
        this.searchList = this.filteredSpecList.filter((item) => this.filterKeyword(item, name));
      }, 500);
    },
    filterKeyword(item, name) {
      const keyArr = ["specName", "templateSpecId"];
      let flag = false;
      while (keyArr[0] && !flag) {
        if (item[keyArr.shift()].includes(name)) flag = true;
      }
      return flag;
    }
  }
};
</script>

<style scoped lang="scss"></style>
